/* eslint-disable react/require-default-props */
/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import { paths } from '../../routes';
import isActiveRoute from '../../utils/isActiveRoute';
import { OptionItem } from './OptionsMenu';

type MegaOptionProps = {
  onItemClick?: (path: string) => void;
  storeName?: string;
};

function MegaOptionsItems({ onItemClick, storeName }: MegaOptionProps) {
  return (
    <div className="px-8 pt-8 pb-2">
      <div className="flex flex-row w-full space-x-12 divide-x-[1.5px]">
        <div className="flex flex-row w-full space-x-10">
          <div>
            <h3 className="px-4 text-pos-black text-base font-semibold uppercase">
              Your Store
            </h3>
            <div className="mt-2 space-y-2">
              <OptionItem
                className={`option text-gray-700 rounded-md ${isActiveRoute(
                  'account-settings',
                )}`}
                onClick={() =>
                  onItemClick?.(
                    paths.PREFERENCES_URL_PATH.replace(':tabId', 'general'),
                  )
                }
              >
                Account & Settings
              </OptionItem>
              <OptionItem
                className={`option text-gray-700 rounded-md 
                ${isActiveRoute('users')}`}
                onClick={() => onItemClick?.(paths.USERS_URL_PATH)}
              >
                Manage Users
              </OptionItem>
              <OptionItem
                className={`option text-gray-700 rounded-md 
                ${isActiveRoute('customers')}`}
                onClick={() => onItemClick?.(paths.CUSTOMERS_URL_PATH)}
              >
                Manage Customers
              </OptionItem>
            </div>
          </div>
          <div>
            <h3 className="px-4 text-pos-black text-base font-semibold uppercase">
              Products
            </h3>
            <div className="mt-2 space-y-2">
              <OptionItem
                className="option text-gray-700 rounded-md"
                onClick={() => onItemClick?.('')}
              >
                Catalog Settings
              </OptionItem>
              <OptionItem
                className={`text-gray-700 rounded-md option 
                ${isActiveRoute('suppliers')}`}
                onClick={() => onItemClick?.(paths.SUPPLIERS_URL_PATH)}
              >
                Manage Suppliers
              </OptionItem>
            </div>
          </div>
        </div>

        <div className="shrink-0 px-8">
          <h3 className="px-4 text-pos-black text-base font-semibold uppercase">
            Tools
          </h3>
          <div className="mt-2 space-y-2">
            <OptionItem
              className={`option text-gray-700 rounded-md ${isActiveRoute(
                'registers',
              )}`}
              onClick={() =>
                window.location.assign(paths.CASH_REGISTER_TELLER_URL_PATH)
              }
            >
              Cash Register
            </OptionItem>
            <OptionItem
              className="option text-gray-700 rounded-md"
              onClick={() => onItemClick?.('')}
            >
              Audit Log
            </OptionItem>
            <OptionItem
              className="option text-gray-700 rounded-md invisible"
              onClick={() => false}
            >
              Is made invisible
            </OptionItem>
          </div>
        </div>
      </div>

      <div className="mt-10 pt-4 pb-2 w-full flex flex-row text-[13px] justify-between border-t gap-4">
        {storeName && (
          <span>
            You are currently viewing settings for store:{' '}
            <button
              type="button"
              onClick={() => window.location.reload()}
              className="text-pos-hyperlink"
            >
              {storeName}
            </button>
          </span>
        )}

        {/* Want to manage another store? */}
        <button
          type="button"
          className="text-pos-hyperlink underline ml-auto"
          onClick={() => window.location.assign(paths.SWITCH_STORE_URL_PATH)}
        >
          Switch to Another Store
        </button>
      </div>
    </div>
  );
}

export default MegaOptionsItems;
